import React, { useState } from "react";
// import { services } from "./services";
import BatchCarousel from "./BatchCarousel";
import SeeAllButton from "./SeeAllButton";



const Batches = () => {
 
  const [allCardsDisplayed, setAllCardsDisplayed] = useState(false);
// function SeeAllButton() {
  const displayAllCards = () => {
    setAllCardsDisplayed(!allCardsDisplayed);
    window.scrollTo(0, 220);
  };
// }
  // console.log("serveses", services);
  return (
    <>
    <div className="container batch pb-5">
      {allCardsDisplayed ? (
    
       <SeeAllButton/>
   
       ): (
        <BatchCarousel />
      
       )
    }
         

      <div id="see-all-button-container" className="text-center mt-4">
        <button
          id="see-all-button"
          className="btn btn-primary sabtn"
          onClick={displayAllCards}
        >
          {allCardsDisplayed ? 'Hide All' : 'See All'}
        </button>
      </div>
      </div>
    </>
  );
};

export default Batches
